import { Group, Loader, Text, ThemeIcon } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useLanguage } from "../../../../stores/LanguageStore";

const OvhKeyValidation = ({ validated, validating, apiKey, hasApiKey }) => {
  const lang = useLanguage((s) => s.language);
  if (validating) {
    return (
      <Group wrap="nowrap" style={{ borderRadius: 16 }}>
        <Loader type="oval" size={48} />
        <Text size="lg">{lang.ovh.no_key.validation}</Text>
      </Group>
    );
  }
  if (validated) {
    return (
      <Group wrap="nowrap" style={{ borderRadius: 16 }}>
        <ThemeIcon size={48} color="green.8" variant="light" radius={"xl"}>
          <IconCheck />
        </ThemeIcon>
        <Text size="lg" c={"green.8"}>
          {lang.ovh.no_key.validated}
        </Text>
      </Group>
    );
  }
  if (apiKey && !validated && !validating) {
    return (
      <Group wrap="nowrap" style={{ borderRadius: 16 }}>
        <ThemeIcon size={64} color="red.8" variant="light" radius={"xl"}>
          <IconX />
        </ThemeIcon>
        <Text size="lg" c={"red.8"}>
          {lang.ovh.no_key.invalid}
        </Text>
      </Group>
    );
  }
  if (hasApiKey)
    return (
      <Group wrap="nowrap" style={{ borderRadius: 16 }}>
        <Text size="lg">{lang.ovh.no_key.will_validate}</Text>
      </Group>
    );
  return "";
};

export default OvhKeyValidation;
